import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wud552r4w: FaireProductEntity = {
  token: "p_7wud552r4w",
  type: "product",
  name: "Soft Paws Hydrating Paw Lotion",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/02a5e81a6a9099f629c9108abbdc9d1a6e349f39b1eca210a4effc80ff80ced8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0155b58da9f7aac3763aad9691e13e51117278c19527a6473d9b209db2cc7414.png",
    "https://cdn.faire.com/fastly/4c86a0c388aa4bfb012b8927be14f0e7e6c1bd45bfc824004233b03eeb013cd6.png",
    "https://cdn.faire.com/fastly/1fd3b4038fe4c670f1bfb7ce10a46ec06823f02a36286294fce1ffaeb39caa0d.png",
    "https://cdn.faire.com/fastly/6894bfa0f7849b86e4a65dbdd0281f8b92a8d601f0d47f34636fd8a9b93a0385.png",
    "https://cdn.faire.com/fastly/5ed50a77a989f0bb78406a0dbc78aafc10182e563589a5cf9eb5e7cb67043e0b.png",
    "https://cdn.faire.com/fastly/113cc51570081f239ebd393f44cab20c7511b6c752c32327ba5f2c18ae3bd55f.png",
    "https://cdn.faire.com/fastly/e14076b6c5c72c9b94f43ca20c2710954decfcdb997eabe8954ca1ada59fe71d.png",
    "https://cdn.faire.com/fastly/370380414adf3e48a0344e9fcb0ca7d83a26077f66e688ebef29b00036e0c35c.png",
    "https://cdn.faire.com/fastly/1a13fec50f2a6d045829e73182ff8aa00bc8076c6d824f1792cd2544a4c98726.png",
    "https://cdn.faire.com/fastly/7b0e35ce7fcd7ccb4540eecbb40874b8199aa425baf849db43c0484e04fdabbd.png",
    "https://cdn.faire.com/fastly/15e297b2efd0d126261f8bd9ef79a26a7b3ee043afaeb29ec04c20dfcdb65003.png"
  ],
  priceDollars: 9,
  description: "The daily moisturizer for your dog's paws. \n\nWhy we love it: Nourish and protect dry, itchy, cracked dog paws\n\nVet-Dermatologist Approved | Fragrance-Free | pH-Balanced for Dogs | Lick-Safe | Vegan | Cruelty-Free\n\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:38.758Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
